import { render, staticRenderFns } from "./FoqcSetList.vue?vue&type=template&id=7c0d4d37"
import script from "./FoqcSetList.vue?vue&type=script&lang=js"
export * from "./FoqcSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports